import Loadable from 'react-loadable';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

const AuthProvider = Loadable({
    loader: () => import(/* webpackChunkName: "Auth" */ './AuthProvider'),
    timeout: 500,
    loading: CircleLoader,
});
export default AuthProvider;
